module.exports = __webpack_public_path__ + "pt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pt.svg
// module id = 769
// module chunks = 0